import React from "react";
import MediaItems from "./MediaItems/MediaItems";
import { useTranslation } from "react-i18next";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";

const Media = () => {
  const { t } = useTranslation();

  return (
    <>
      <Breadcrumb title={t("Media")} />
 
      <MediaItems />
    </>
  );
};

export default Media;
